import type { RouteObject } from 'react-router-dom';

import AuthLayout from '@/app/layouts/AuthLayout/AuthLayout';
import { DesktopAuthGuard } from '@/app/router/guards';
import { lazyRoute } from '@/app/router/helpers';
import { ROUTES } from '@/shared/constants/app/routes.constant.ts';

/**
 * 데스크톱(XCOST) 브라우저 로그인. 인증 카드와 같은 미니멀 레이아웃을 쓴다.
 * GuestGuard 아래 두면 안 된다 — 로그인한 사용자가 동의하는 화면이다.
 */
export const desktopRoutes: RouteObject = {
  Component: AuthLayout,
  path: ROUTES.DESKTOP,
  children: [
    {
      element: <DesktopAuthGuard />,
      children: [
        {
          path: ROUTES.DESKTOP_AUTHORIZE,
          ...lazyRoute(() => import('@/pages/desktop/DesktopAuthorizePage')),
        },
        {
          path: ROUTES.DESKTOP_DEVICES,
          ...lazyRoute(() => import('@/pages/desktop/DesktopDevicesPage')),
        },
      ],
    },
    // 가드 밖 — 루프백 302 로 오는 순간 웹 세션이 없어도(다른 브라우저 프로필 등) 보여야 한다.
    {
      path: ROUTES.DESKTOP_COMPLETE,
      ...lazyRoute(() => import('@/pages/desktop/DesktopCompletePage')),
    },
  ],
};
